import { frontendURL } from '../../../../helper/URLHelper';
import { ROLES } from 'dashboard/constants/permissions.js';
import SettingsWrapper from '../SettingsWrapper.vue';
import EmailTemplatesHome from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/email-templates'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'email_templates_index', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'email_templates_index',
          meta: {
            permissions: [...ROLES],
          },
          component: EmailTemplatesHome,
        },
      ],
    },
  ],
};
